module.exports = __webpack_public_path__ + "static/img/detailTitle-lbsjd.7e92c91.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/detailTitle-lbsjd.png
// module id = 10
// module chunks = 0